// «¿Esto se usa o está de adorno?», respondido con números.
//
// Sale del prototipo (`StatCardGrid`), conectado a
// `GET /api/agent/v1/tools/{tool_id}/stats/`. Los nombres de los campos son los
// que devuelve el endpoint; no se inventa ninguno ni se calcula nada aquí: una
// cifra derivada en la pantalla ya no es rastreable hasta su llamada.

import { useTranslation } from 'react-i18next'
import type { Estadisticas } from './formas'
import { RotuloDeSeccion } from '@/components/ui/rotulo-de-seccion'

function Tarjeta({ etiqueta, valor }: { etiqueta: string; valor: string }) {
  return (
    <div className="rounded-md border bg-background/60 px-2 py-1.5">
      <RotuloDeSeccion>{etiqueta}</RotuloDeSeccion>
      <p className="font-mono text-sm font-semibold">{valor}</p>
    </div>
  )
}

export function EstadisticasDeHerramienta({ datos }: { datos: Estadisticas }) {
  const { t } = useTranslation()
  const e = datos.executions ?? {}
  const total = e.total ?? 0

  return (
    <div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <Tarjeta etiqueta={t('brain.veces_usada')} valor={String(total)} />
        <Tarjeta etiqueta={t('brain.bien')} valor={String(e.successful ?? 0)} />
        <Tarjeta etiqueta={t('brain.con_fallo')} valor={String(e.failed ?? 0)} />
        <Tarjeta
          etiqueta={t('brain.tarda')}
          valor={`${Math.round(datos.performance?.avg_execution_time_ms ?? 0)} ms`}
        />
      </div>
      {total === 0 && (
        // Cuatro ceros se leen igual que «no hay datos» y significan otra cosa:
        // la herramienta esta puesta y nadie la ha llamado nunca. Decirlo evita
        // que se lea como un fallo de la pantalla.
        <p className="mt-1.5 text-xs text-muted-foreground">{t('brain.nunca_usada')}</p>
      )}
    </div>
  )
}
